import { render, staticRenderFns } from "./TermInput.vue?vue&type=template&id=28a86a26"
import script from "./TermInput.vue?vue&type=script&lang=js"
export * from "./TermInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports